import { render, staticRenderFns } from "./next.vue?vue&type=template&id=fd9f9bfa&scoped=true"
import script from "./next.vue?vue&type=script&lang=js"
export * from "./next.vue?vue&type=script&lang=js"
import style0 from "../assets/css/next.scss?vue&type=style&index=0&id=fd9f9bfa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9f9bfa",
  null
  
)

export default component.exports